import { Company } from "../domain/Company";
import { SelectEInvContractPopup, ServiceDelivery } from "../domain/ServiceDelivery";

export class VueSelectWorkingHoursContractPopup implements SelectEInvContractPopup {
    showed: boolean;
    companies: Company[];
    sd: ServiceDelivery;
    resolve_prom

    constructor() {
        this.showed = false;
    }

    show() {
        this.showed = true;
        return new Promise((resolve) => {
            this.resolve_prom = resolve
        });
    }

    set_companies(companies) {
        this.companies = companies;
    }

    set_sd(sd) {
        this.sd = sd
    }

    close(company) {
        this.showed = false;
        this.resolve_prom(company);
    }
}
